// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { InvoiceHeader } from './invoice-header';
import { ManifestGroup } from './manifest-group';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ManifestGroupInvoice extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key FK manifestGroup */
  manifestGroupId!: number;
  /** String(10) key FK invoiceHeader */
  invoiceHeaderId!: string;
  /** DateTimeOffset */
  modTs?: Date;
  /** FK invoiceHeaderId */
  invoiceHeader!: InvoiceHeader;
  /** FK manifestGroupId */
  manifestGroup!: ManifestGroup;
}

